export const ADD_AND_RESET_FORM = 'ADD_AND_RESET_FORM';
export const SET_FORM_ELEMENT_VALUE = 'SET_FORM_ELEMENT_VALUE';
export const SET_FORM_ERRORS = 'SET_FORM_ERRORS';
export const SET_FORM_POPUP_OPEN = 'SET_FORM_POPUP_OPEN';
